import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { ProjectEditPage } from '@/areas/projects/ProjectEdit/ProjectEditPage';
import { canEditProject } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/projects/$projectId/edit')({
    staticData: { access: { permissions: canEditProject }, chrome: 'project' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return <ProjectEditPage rfqId={pathParams.projectId} />;
}
